// removed by extract-text-webpack-plugin
module.exports = {"Login":"GZbegBsdMIq2RiyH9INB5","Quote":"jib0qTnO6iZYqFwD5w9Gf","LoginPanel":"_2K-dsiF_kq3OOc28Cjibu_","Title":"_3F6rbKNYbM6ZTDIwn-8AxB","Input":"_8WdiVltK98j8Xr809U9WB","ButtonContainer":"_3EMogamzRhyqI7-W10Z2yN","SignInButton":"_3vzDKQOxk9DSuDFEG7Lr6Z","RegisterButton":"_5iGOfzt19fbBQU0CEcsFS","Button":"_3rdPP-2N97iYT0FvFvZQV1","Error":"_37-M3PExN02mZOPlEv9Unh","ForgotPassword":"_2EMUoACvZq5geLZtIHIarq"};


//////////////////
// WEBPACK FOOTER
// ./src/ConnectedComponents/Login/index.css
// module id = 1422
// module chunks = 1